import { withNavigation }      from 'components/App/withNavigation';
import { WithNavigationProps } from 'components/App/withNavigation';
import React                   from 'react';
import { Button }              from 'antd';
import { Link }                from 'react-router-dom';
import handleApiError          from 'utils/handleApiError';
import PublicLayout            from 'containers/Security/PublicLayout';
import ResetPasswordModel      from 'models/ResetPasswordModel';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import Input                   from 'components/App/IntlInput';
import Space                   from 'components/App/Space';

interface PasswordForgottenState {
  email: string;
  errors: any[];
  submitted: boolean;
}

class PasswordForgotten extends React.Component<WithNavigationProps> {
  public state: PasswordForgottenState = {
    email: '',
    errors: [],
    submitted: false,
  };

  public render() {
    return (
      <PublicLayout>
        <Space size={24}>
          <h2>Mot de passe oublié</h2>

          {!this.state.submitted ? (
            <Space size={12}>
              <p>
                <FormattedMessageWrapper id="Indiquez votre adresse email afin de recevoir les instructions à suivre pour récupérer votre mot de passe." />
              </p>

              <Input
                onChange={(event: any) => this.setState({ email: event.target.value })}
                placeholder="Email"
                style={{ textAlign: 'center' }}
                value={this.state.email}
              />

              {this.state.errors.map((error, index) => (
                <div key={index} style={{ color: '#e74c3c' }}>{error}</div>
              ))}

              <Button
                htmlType="button"
                onClick={this.handleSubmit}
                style={{ width: '100%' }}
                type="primary"
              >
                <FormattedMessageWrapper id="Envoyer" />
              </Button>
            </Space>
          ) : (
            <p>
              <FormattedMessageWrapper id="Si votre adresse mail existe bien, un mail va bientôt vous être envoyé." />
            </p>
          )}

          <Link to="/login">
            <FormattedMessageWrapper id="Retour" />
          </Link>
        </Space>
      </PublicLayout>
    );
  }

  private handleSubmit = async () => {
    if (this.state.email === '' || !this.state.email.match(/.+@.+\..+/gm)) {
      this.setState({
        errors: [<FormattedMessageWrapper id="Adresse email incorrecte." key="email_invalid" />],
      });
      return;
    }

    const resetPasswordModel = new ResetPasswordModel();

    const options = {
      data: JSON.stringify({
        email: this.state.email,
        routeUrl: window.location.href.replace(
          this.props.location?.pathname,
          '/reinitialisation-mot-de-passe',
        ),
      }),
      headers: {
        'content-type': 'application/json',
      },
    };

    try {
      await resetPasswordModel.save(options);
      this.setState({ submitted: true });
    } catch (error) {
      // // we ignore 422 for sentry
      // if (error.connectorError.request.status !== 422) {
      //   throw error;
      // }
      handleApiError(error);
    }
  };
}

const PasswordForgottenWithNavigation = withNavigation(PasswordForgotten);

export default PasswordForgottenWithNavigation;